import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/site-data";

export default function FAQ() {
  return (
    <section id="faq" className="py-20 md:py-28" data-testid="faq-section">
      <div className="container-site">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <p className="overline mb-3">Questions?</p>
            <h2 className="font-serif text-4xl md:text-5xl text-brand-pine leading-tight">
              Everything you wondered <span className="italic text-brand-clay">before booking.</span>
            </h2>
            <p className="mt-5 text-brand-textMuted leading-relaxed">
              If your question isn't here, just WhatsApp us. We usually reply
              within minutes during working hours.
            </p>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  value={`item-${i}`}
                  key={i}
                  className="border-b border-brand-line last:border-b-0"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="font-serif text-xl md:text-2xl text-brand-pine text-left hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-brand-textMuted text-[15px] leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
